import { useLazyQuery, useQuery } from "@apollo/client";
import { VISITS } from "../visit.queries";
import { VisitsQuery, VisitsQueryVariables } from "../../../__generated__/VisitsQuery";

export const useVisits = (variables: VisitsQueryVariables) => {
  return useQuery<VisitsQuery, VisitsQueryVariables>(VISITS, { variables });
};

export const useLazyVisits = () => {
  return useLazyQuery<VisitsQuery, VisitsQueryVariables>(VISITS);
};
